// extracted by mini-css-extract-plugin
export default {"badgeText":"uFx9pR"};